<template>
  <li
    v-if="member"
    class="side-members__item member"
    @click="onClickMember">
    <div
      class="px-3 pt-3 pb-2"
      :class="tabClass">
      <div class="d-flex align-items-center">
        <img
          v-if="member.avatar"
          :src="member.avatar"
          class="img-fluid rounded-circle side-member__img mr-3 align-self-center">
        <span
          v-else
          class="material-icons member__icon mr-3 p-1 align-self-center">
          person
        </span>
        <div
          class="side-member__content"
          :class="{searched: isSearched}">
          <p class="side-member__name">
            {{ member.name }}
          </p>
          <p class="side-member__title">
            {{ member.position }}
          </p>
        </div>
        <div class="side-members__suffix">
          <slot name="suffix" />
        </div>
      </div>
      <daily-work-stack-list
        class="mt-1"
        :selected-date="selectedDate"
        :daily-work-list="dailyWorkList" />
    </div>
  </li>
</template>

<script>
import DailyWorkStackList from '@/components/view/DailyWorkStackList.vue'

export default {
  components: {
    DailyWorkStackList
  },
  props: {
    member: { 
      type: Object,
      default: null
    },
    selectedDate: {
      type: Date,
      required: true
    },
    dailyWorkList: {
      type: Array,
      default: () => []
    },
    isSearched: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tabClass() {
      if (this.isActive) {
        return 'side-member__link--current'
      }
      return 'side-member__link'
    },
    isActive() {
      return this.member.id === this.$route.params.id
    }
  },
  methods: {
    onClickMember() {
      this.$router.push(`/members/${this.member.id}`)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/members';
@import '@/assets/stylesheets/member';

.side-members {
  &__item {
    position: relative;
    cursor: pointer;
  }

  &__suffix {
    margin-left: auto;
  }
}

.side-member__content {
  flex-grow: 1;
  padding: 5px 10px;
  margin-left: -10px;
  margin-right: 10px;
  border-radius: 5px;

  &.searched {
    background: $highlight;
  }
}
</style>